import './FilterDropdownTrigger.scss'

import classNames from 'classnames'
import CaretDown from 'icons/CaretDown'
import Dropdown from 'lib/components/Dropdown/Dropdown'
import React, { HTMLAttributes, ReactNode } from 'react'

export interface FilterDropdownTriggerProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
  className?: string
}

export default function FilterDropdownTrigger(props: FilterDropdownTriggerProps) {
  const { className, children, ...otherProps } = props
  const mergedClassName = classNames('filter-dropdown-trigger', className)

  return (
    <Dropdown.Trigger className={mergedClassName} {...otherProps}>
      {children}
      <CaretDown />
    </Dropdown.Trigger>
  )
}
